// @ts-nocheck
import React, { memo, useState, useEffect } from 'react'
import { useUserDetails } from 'utils/hooks/useUserDetails'
import { POLICY_TYPES } from 'apps/carrier/constants/insurance'
import { isInsuranceValid } from 'apps/carrier/utils/insurance'
import { Checkbox } from 'components/forms'
import { FormModal } from 'transfix-ui'
import { NeedPermissionModal } from '../../NeedPermissionModal'
import AutomobileLiability from './AutomobileLiability'
import CargoCoverageLiability from './CargoCoverageLiability'
import DishonestyCoverage from './DishonestyCoverage'
import GeneralLiability from './GeneralLiability'
import TrailerInterchangeCoverage from './TrailerInterchangeCoverage'
import WorkersCompensation from './WorkersCompensation'

const sections = [
  { section: AutomobileLiability, type: 'automotiveInsurance' },
  { section: GeneralLiability, type: 'generalInsurance' },
  { section: CargoCoverageLiability, type: 'cargoInsurance' },
  { section: TrailerInterchangeCoverage, type: 'trailerInterchangeInsurance' },
  { section: DishonestyCoverage, type: 'dishonestyInsurance' },
  { section: WorkersCompensation, type: 'workersCompensationInsurance' },
]

const useInsurance = (carrierId, initialState, dialogOpen) => {
  const [insurances, setInsurance] = useState({})
  // set defaults
  if (!insurances.automotiveInsurance || !insurances.automotiveInsurance.policyType) {
    setInsurance({
      ...insurances,
      automotiveInsurance: {
        ...insurances.automotiveInsurance,
        policyType: POLICY_TYPES[0].value,
      },
    })
  }
  useEffect(() => {
    if (carrierId && dialogOpen) {
      setInsurance(initialState || {})
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [carrierId, dialogOpen])
  const onChange = (changes, type) =>
    setInsurance(current => {
      const diff = type ? { [type]: { ...current[type], ...changes } } : changes
      return { ...current, ...diff }
    })
  return [insurances, onChange]
}
interface IInsuranceDialogProps {
  canEdit?: boolean
  carrierId?: number
  insurances?: {
    reviewed: string
    automotiveInsurance: string
  }
  dialogOpen: boolean
  error?: string
  closeDialog: (action?: string) => any
  updateInsurance?: (...args: any[]) => any
  updating?: boolean
}

const InsuranceDialog: React.FunctionComponent<IInsuranceDialogProps> = memo(
  ({
    carrierId,
    closeDialog,
    dialogOpen,
    error,
    insurances: initialState,
    updateInsurance,
    updating,
  }) => {
    const { userPermissions } = useUserDetails()
    const canEdit = userPermissions?.canEditCarrierInsurances
    const [insurances, onChange] = useInsurance(carrierId, initialState, dialogOpen)
    const onReviewed = () => onChange({ reviewed: !insurances.reviewed })
    const onSubmit = () => updateInsurance(carrierId, insurances)
    const { contactInfo: automotiveContactInformation } = insurances.automotiveInsurance || {
      contactInfo: {},
    }
    const submitDisabled = updating || !isInsuranceValid(insurances)
    return canEdit ? (
      <FormModal
        title='Edit Insurance'
        size={6}
        open={dialogOpen}
        onClose={closeDialog}
        error={error}
        dataTest='edit-insurance-modal'
        actions={[
          {
            label: 'Cancel',
            type: 'dismiss',
            disabled: updating,
            dataTest: 'cancel-insurance',
          },
          {
            label: 'Save',
            type: 'confirm',
            disabled: submitDisabled,
            action: onSubmit,
            dataTest: 'save-insurance',
          },
        ]}>
        <div className='pv4'>
          {sections.map(({ section: Section, type }) => (
            <Section
              key={type}
              type={type}
              onChange={onChange}
              automotiveContactInformation={automotiveContactInformation}
              // eslint-disable-next-line react/jsx-props-no-spreading
              {...insurances[type]}
            />
          ))}
        </div>
        <Checkbox
          id='insurance-reviewed'
          dataTest='insurance-reviewed'
          label='Reviewed'
          checked={insurances.reviewed}
          onChange={onReviewed}
        />
        <br />
      </FormModal>
    ) : (
      <NeedPermissionModal
        action='edit a carrier’s insurance'
        contact='Compliance'
        open={dialogOpen}
        onClose={closeDialog}
      />
    )
  }
)

export default InsuranceDialog
